<template>
    <div class="advantage">
        <span class="icon"><slot /></span>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.advantage {
    border: 9px solid rgba(255, 255, 255, 0.3);
    border-radius: 25px;
    box-shadow: 0px -26px 24.1px 0px #0A77FF0D inset, 0px 7px 40px 0px #956B4914;
}

.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 46px;
    background-color: #FCFDFF;
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 32px;
    font-weight: 600;
    border-radius: 16px;

    @media (max-width: 900px) {
      width: 36px;
      height: 36px;
      border-radius: 13px;
    }

    @media (max-width: 600px) {
      width: 24px;
      height: 24px;
      border-radius: 10px;
    }
}
</style>
